/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Not_Found_BodyInputs */

const cs_public_site_not_found_body = /** @type {(inputs: Public_Site_Not_Found_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuto kancelář se nepodařilo najít. Zkontrolujte prosím adresu.`)
};

const en_public_site_not_found_body = /** @type {(inputs: Public_Site_Not_Found_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not find this office. Please check the address.`)
};

/**
* | output |
* | --- |
* | "We could not find this office. Please check the address." |
*
* @param {Public_Site_Not_Found_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_not_found_body = /** @type {((inputs?: Public_Site_Not_Found_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Not_Found_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_not_found_body(inputs)
	return cs_public_site_not_found_body(inputs)
});